import { Path } from "./Constant/RoutePaths";
import PaymentMode from "../Pages/PaymentMode";
import PaymentDetails from "../Pages/PaymentDetails";
import TransactionFailed from "../Pages/TransactionFailed";
import Unauthorized from "../Pages/Unauthorized";
import RedirectAfterPayment from "../Pages/redirectPageAfterPayment";
import UnderMaintenance from "../Pages/UnderMaintenance";

export const PAGES = {
  PUBLIC_PAGES: [{ path: Path.UNAUTHORIZED_INPUT, element: <Unauthorized /> }],
  MAINTENANCE_PAGE: [{ path: Path.UNDER_MAINTENANCE, element: <UnderMaintenance /> }],
  PRIVATE_PAGES: [
    { path: Path.PAYMENTMODE, element: <PaymentMode /> },
    { path: Path.PAYMENTDETAILS, element: <PaymentDetails /> },
    { path: Path.TRANSACTION_FAILED, element: <TransactionFailed /> },
    { path: Path.REDIRECT_AFTER_PAYMENT, element: <RedirectAfterPayment /> },
    { path: Path.UNAUTHORIZED_INPUT, element: <Unauthorized /> },
  ],
};
